import React, { useEffect } from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import AOS from "aos";
import "aos/dist/aos.css";
import image from "../assests/services_image_2.jpg"
import { Link } from "react-router-dom";
import NewsletterSection from "./NewsLetter";
import HeroSection from "./HeroSection";

const Services1 = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });

    window.scrollTo(0, 0);
  }, []);

  const features = [
    "Easy-to-use monitoring and control access",
    "Telecommands generation and management",
    "Non-Destructive Testing",
    "Aerospace Polymers and Plastics Testing",
    "Cloud-based AI mission control",
    "High-performance infrastructure",
    "Advanced encryption and authentication",
    "Mechanical Testing",
    "Aerospace Composites Testing"
  ];

  const midpoint = Math.ceil(features.length / 2);
  const leftColumnFeatures = features.slice(0, midpoint);
  const rightColumnFeatures = features.slice(midpoint);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Navbar />
      
      {/* Hero Section */}
      {/* <div className="bg-customBlue text-white py-12">
      <div className="max-w-6xl mx-auto px-6">
        <div data-aos="fade-up" className="space-y-4 flex flex-col items-center text-center">
          <h1 className="font-nova-square text-4xl font-thin text-black">
            Mission Control Software for Cubesat
          </h1>
          <p className="text-black">
          <Link to={"/"}> Home </Link>{' > '} <Link to={"/products"}>Products </Link> {'>'} <Link to={"/products/products1"}> Mission Control Software for Cubesat </Link>
          </p>
        </div>
      </div>
      </div> */}

      <HeroSection 
        title="Mission Control Software for Cubesat" 
        breadcrumb={
          <>
            <Link to={"/products"}>Products</Link> {' > '} 
            <Link to={"/products/products1"}>Mission Control Software for Cubesat</Link>
          </>
        } 
      />

      <div className="max-w-6xl mx-auto p-6">
        {/* Image Section */}
        <div className="flex flex-col md:flex-row items-center gap-8 max-w-6xl mx-auto">
      <div data-aos="zoom-in" className="md:w-1/2">
        <div className="relative group overflow-hidden rounded-xl shadow-2xl">
          <img
            src={image}
            alt="Mission Control Software"
            className="w-full h-[300px] object-cover transform transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        </div>
      </div>
      {/* Introduction */}
      <div data-aos="fade-up" className="prose max-w-none md:w-1/2 space-y-5">
        <p className="text-lg text-gray-700 leading-relaxed text-justify">
          Mission Control Software (MCS) provides an easy-to-use monitoring and control access to any space mission. Harnessing the power of AI, the application supervises automation and unattended operations, significantly improving the efficiency and scalability of the mission.
        </p>
        <hr className="border-gray-300 my-4" />
        <p className="text-lg text-gray-700 leading-relaxed text-justify">
              CALISTO is a powerful cloud-based AI mission control software suite designed to control a single satellite or a complete constellation through a user-friendly, fully customizable control web interface.
            </p>
      </div>
    </div>
      
      

        {/* Content Sections */}
        <div className="mt-12 space-y-8">
          {/* Introduction */}
          
          {/* CALISTO Overview */}
          <div data-aos="fade-up" className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
            <h2 className="font-nova-square text-2xl font-bold text-gray-800 mb-4">CALISTO Platform</h2>
            <p className="text-lg text-gray-700 text-justify">
              CALISTO is a powerful cloud-based AI mission control software suite designed to control a single satellite or a complete constellation through a user-friendly, fully customizable control web interface.
            </p>
          </div>

          {/* Key Features */}
          <div data-aos="fade-up" className="grid md:grid-cols-3 gap-6">
            {[
              {
                title: "Telemetry & Control",
                description: "Advanced telemetry, trajectory updates, and telecommand capabilities through web-based interface",
                icon: "📡"
              },
              {
                title: "3D Visualization",
                description: "Sophisticated orbit visualization tool with satellite tracking based on TLE propagation",
                icon: "🛰"
              },
              {
                title: "Security",
                description: "AES256 encryption with 2FA token authentication for state-of-the-art protection",
                icon: "🔒"
              }
            ].map((feature, index) => (
              <div 
                key={index}
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
              >
                <div className="text-4xl mb-4">{feature.icon}</div>
                <h3 className="font-nova-square text-xl font-semibold text-gray-800 mb-2">{feature.title}</h3>
                <p className="text-gray-600 text-justify text-lg">{feature.description}</p>
              </div>
            ))}
          </div>

          {/* Capabilities List */}
          {/* <div data-aos="fade-up" className="bg-white rounded-xl p-8 shadow-lg">
            <h2 className="font-nova-square text-2xl font-bold text-gray-800 mb-6">Technical Capabilities</h2>
            <div className="grid md:grid-cols-2 gap-4">
              {[
                "Easy-to-use monitoring and control access",
                "Telecommands generation and management",
                "Non-Destructive Testing",
                "Aerospace Polymers and Plastics Testing",
                "Cloud-based AI mission control",
                "High-performance infrastructure",
                "Advanced encryption and authentication",
                "Mechanical Testing",
                "Aerospace Composites Testing"
              ].map((item, index) => (
                <div 
                  key={index}
                  className="flex items-center space-x-3 p-3 rounded-lg hover:bg-blue-50 transition-colors duration-300"
                >
                  <div className="h-2 w-2 rounded-full bg-blue-500" />
                  <span className="text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </div> */}

          <div data-aos="fade-up" className="bg-white rounded-xl p-8 shadow-lg">
      <h2 className="font-nova-square text-2xl font-bold text-gray-800 mb-6">
        Technical Capabilities
      </h2>
      <div className="grid md:grid-cols-2 gap-8">
        <style>
          {`
            .feature-list {
              list-style: none;
              padding-left: 0;
              border-left: 3px solid #3B82F6;
              margin-left: 10px;
              padding-left: 20px;
            }
            
            .feature-list li {
              padding: 12px 0;
              position: relative;
              margin-bottom: 15px;
              color: #374151;
              transition: transform 0.3s ease;
            }
            
            .feature-list li:hover {
              transform: translateX(10px);
            }
            
            .feature-list li::before {
              content: "→";
              position: absolute;
              left: -30px;
              top: 50%;
              transform: translateY(-50%);
              color: #3B82F6;
              font-weight: bold;
              opacity: 0;
              transition: opacity 0.3s ease;
            }
            
            .feature-list li:hover::before {
              opacity: 1;
            }
          `}
        </style>
        
        {/* Left Column */}
        <ul className="feature-list">
          {leftColumnFeatures.map((feature, index) => (
            <li
              key={index}
              className="text-gray-700"
            >
              {feature}
            </li>
          ))}
        </ul>

        {/* Right Column */}
        <ul className="feature-list">
          {rightColumnFeatures.map((feature, index) => (
            <li
              key={index + midpoint}
              className="text-gray-700"
            >
              {feature}
            </li>
          ))}
        </ul>
      </div>
    </div>
    
        </div>
      </div>

      <NewsletterSection />
      <Footer />
    </div>
  );
};

export default Services1;